import {
	resetBillingPages,
	resetClaimsBilling,
	setSubTabSelected,
	setTabSelected,
} from 'feature/billing/billingSlice';
import { resetForm, setSearch, setSortingValues } from 'feature/form/formSlice';
import { resetTableSelection } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Stack, Typography } from 'styles';
import { EBillingSubTab } from 'types/Billing';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const LINK_STYLE = {
	textDecoration: 'underline',
	textUnderlineOffset: '8px',
};

const BillingTabs = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { tabSelected, subTabSelected } = useSelector(
		(store: RootState) => store.billing,
	);
	const dispatch = useDispatch<AppDispatch>();

	const onChangeTab = (type: 'claims' | 'admin') => {
		dispatch(setTabSelected(type));
		dispatch(setSubTabSelected(EBillingSubTab.CLAIMS));
		dispatch(resetClaimsBilling());
		dispatch(resetForm());
		dispatch(resetTableSelection());
		dispatch(resetBillingPages());
		dispatch(setSearch(true));
		dispatch(
			setSortingValues({
				name: 'externalClaimId,claimDate',
				value: 'DESC,DESC',
			}),
		);
	};

	const onChangeSubTab = (type: EBillingSubTab) => {
		dispatch(setSubTabSelected(type));
		dispatch(resetClaimsBilling());
		dispatch(resetForm());
		dispatch(resetTableSelection());
		dispatch(resetBillingPages());
		dispatch(setSearch(true));
		dispatch(
			setSortingValues({
				name: 'externalClaimId,claimDate',
				value: 'DESC,DESC',
			}),
		);
	};

	return (
		<Stack gap={4}>
			<Stack direction={'row'} gap={4} mb={tabSelected === 'admin' ? 0 : 4}>
				<Typography
					sx={{
						cursor: 'pointer',
						...(tabSelected === 'claims' ? LINK_STYLE : {}),
					}}
					variant="value1"
					onClick={() => onChangeTab('claims')}
				>
					{tClientLabels('billing.tabs.claims')}
				</Typography>
				<Typography
					sx={{
						cursor: 'pointer',
						...(tabSelected === 'admin' ? LINK_STYLE : {}),
					}}
					variant="value1"
					onClick={() => onChangeTab('admin')}
				>
					{tClientLabels('billing.tabs.admin')}
				</Typography>
			</Stack>
			{tabSelected === 'admin' && (
				<Stack direction={'row'} gap={4} mb={4}>
					<Typography
						sx={{
							cursor: 'pointer',
							...(subTabSelected === EBillingSubTab.CLAIMS ? LINK_STYLE : {}),
						}}
						variant="value1"
						onClick={() => onChangeSubTab(EBillingSubTab.CLAIMS)}
					>
						{tClientLabels('billing.tabs.sub.claims')}
					</Typography>
					<Typography
						sx={{
							cursor: 'pointer',
							...(subTabSelected === EBillingSubTab.MEMBERS ? LINK_STYLE : {}),
						}}
						variant="value1"
						onClick={() => onChangeSubTab(EBillingSubTab.MEMBERS)}
					>
						{tClientLabels('billing.tabs.sub.members')}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default BillingTabs;
